import React from 'react';
import PropTypes from 'prop-types';

import { faListCheck } from '@fortawesome/pro-solid-svg-icons';

import EmptyState from 'components/empty_state';

const PlannerEmptyState = ({ children, message }) => {
  return (
    <EmptyState
      header="No tasks or critical dates"
      icon={faListCheck}
      subheader={message}
    >
      {children}
    </EmptyState>
  );
};

PlannerEmptyState.propTypes = {
  children: PropTypes.node,
  message: PropTypes.string,
};

export default PlannerEmptyState;
